import { render, staticRenderFns } from "./ProtocolInfo.vue?vue&type=template&id=631e239a&"
import script from "./ProtocolInfo.vue?vue&type=script&lang=ts&"
export * from "./ProtocolInfo.vue?vue&type=script&lang=ts&"
import style0 from "./ProtocolInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports